export default "__VITE_ASSET__4c5199db__"